const getGameTileWidth = gameTileNode => gameTileNode?.clientWidth + 14;

const getGameTileHeight = gameTileNode => gameTileNode?.clientHeight;

const offSetOfAtLeastGameTiles = (widthOfCarouselWindow, widthOfGameTile) => {
  if (Number.isNaN(widthOfGameTile)) {
    return 0;
  }
  return Math.floor(widthOfCarouselWindow / widthOfGameTile) * widthOfGameTile;
};

const getCurrentOffset = carouselScrollNode => carouselScrollNode?.offsetLeft;

const getNumOfGamesScrolled = refs => {
  const { carouselScroll, gameTile } = refs;
  const widthOfGameTile = getGameTileWidth(gameTile);
  if (Number.isNaN(widthOfGameTile)) {
    return 0;
  }
  return Math.ceil(Math.abs(getCurrentOffset(carouselScroll)) / widthOfGameTile);
};

const getNumOfGamesFitted = (currentWindowWidth, gameTileWidth) => {
  if (Number.isNaN(gameTileWidth)) {
    return 0;
  }
  return Math.floor(currentWindowWidth / gameTileWidth);
};

const isStartPoint = offsetLeft => {
  return offsetLeft === 0;
};

const isScrollingEnded = (scrollListWidth, currentWindowWidth, offsetLeft) => {
  const offSetLeftValue = Math.abs(offsetLeft);
  return offSetLeftValue + currentWindowWidth >= scrollListWidth;
};

const scrollPrev = (carouselScrollOffset, currentWindowWidth, gameTileWidth) => {
  return carouselScrollOffset + offSetOfAtLeastGameTiles(currentWindowWidth, gameTileWidth);
};

const scrollNext = (carouselScrollOffset, currentWindowWidth, gameTileWidth) => {
  return carouselScrollOffset - offSetOfAtLeastGameTiles(currentWindowWidth, gameTileWidth);
};

export default {
  scrollPrev,
  scrollNext,
  getCurrentOffset,
  getGameTileHeight,
  getNumOfGamesScrolled,
  getNumOfGamesFitted,
  isStartPoint,
  isScrollingEnded,
  getGameTileWidth
};
